import React from 'react';
import clsx from 'clsx';
import {Styles} from "../../../config/design/styles";
import Button from "@mui/material/Button";
import {CircularProgress} from "@mui/material";
import {withStyles} from "@mui/styles";

class LoadingButton extends React.Component{
    state= {
        loading:false,
        success:false
    };
    componentDidMount(){
        this.setState({
            loading:this.props.loading,
            success:this.props.success
        })
    }
    classes = this.props.classes;
    render(){
        let {children,type,variant,color,onClick,size,loading,success,style,disabled,startIcon,styleForParent} =this.props;
        let buttonClassName = clsx({
            [this.classes.buttonSuccess]: success,
        });
    return (
        <div style={styleForParent} className={this.classes.LoadingButtonWrapper}>
            <Button
                variant={variant}
                type={type}
                style={style}
                color={color}
                startIcon={startIcon}
                className={buttonClassName}
                disabled={disabled || loading}
                onClick={onClick}
                size={size}
            >
                {children}
            </Button>
            {loading && <CircularProgress size={24} className={this.classes.buttonProgress} />}
        </div>
    );
}
}
export default withStyles(Styles)(LoadingButton);